export const base_path = "/";
export const image_path ='/';
export const base_url = "/api";




